import axios from '@/axios'

const state = {
  dependants: null
}

const getters = {
  dependants: state => state.dependants
}

const mutations = {
  SET_DEPENDANTS: (state, dependants) => {
    state.dependants = dependants
  }
}

const actions = {
  getDependants({commit}) {
    return axios.get(`/dependants/`).then(response => {
      commit('SET_DEPENDANTS', response.data)
      return response.data
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
